import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { api, errorMessage } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      title="Reset password."
      subtitle="Forgot password"
      footer={<div>Remembered it? <Link to="/login" className="link-underline font-semibold text-foreground">Back to sign in</Link></div>}
    >
      {sent ? (
        <div data-testid="forgot-sent" className="border border-border p-5 bg-accent/60">
          <div className="font-display font-bold text-[15px] mb-2">Check your inbox.</div>
          <p className="text-[13.5px] text-muted-foreground leading-relaxed">
            If an account exists for <strong className="text-foreground">{email}</strong>, a reset link has been emailed. The link expires in 1 hour.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[12px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">Email</label>
            <input data-testid="forgot-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full h-11 px-3 border border-border bg-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
          </div>
          {error && <div className="text-[13px] text-destructive">{error}</div>}
          <button data-testid="forgot-submit-button" disabled={loading} type="submit"
            className="w-full h-11 bg-primary text-primary-foreground font-semibold text-[14px] hover:bg-[#001d6b] disabled:opacity-60">
            {loading ? "Sending..." : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
